import { render } from "./InclusionCard.vue?vue&type=template&id=c8a71fea&scoped=true&ts=true&lang=pug"
import script from "./InclusionCard.vue?vue&type=script&lang=ts&setup=true"
export * from "./InclusionCard.vue?vue&type=script&lang=ts&setup=true"

import "./InclusionCard.vue?vue&type=style&index=0&id=c8a71fea&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src2191176947/src/lottrackr-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c8a71fea"]])

export default __exports__